// extracted by mini-css-extract-plugin
export default {"sortingMenuButton":"sorting-dropdown-module__sortingMenuButton--awYjR"};